import { format } from 'date-fns'

import safeFilename from '../safeFilename'

/**
 * Builds a safe .ics filename from an event title and date.
 * Uses date (yyyyMMdd) + sanitized title, or title only when date is missing.
 *
 * @param date - JS Date (formatted with date-fns as yyyyMMdd)
 * @param title - Event title (will be sanitized for filesystem)
 * @returns Safe filename ending in .ics
 */
export default function icsFilename(
    date: Date,
    title: string,
): `${string}.ics` {
    const datePart = format(date, 'yyyyMMdd')
    const titlePart = safeFilename(title)
    const parts = [datePart, titlePart]

    return `${parts.filter(Boolean).join('-')}.ics`
}
